export const PURCHASE_TYPE = {
  INVENTORY: 'inventory',
  PROJECT: 'project',
  PROJECT_OR_INVENTORY: 'projectOrInventory',
}

export type PurchaseTypes = typeof PURCHASE_TYPE[keyof typeof PURCHASE_TYPE]
